export const SELECT_MODAL_WIDTH = '440px';
export const ICON_SIZE = '22px';
